import React, { useEffect, useState } from "react";
import { TypeAnimation } from "react-type-animation";
import Loader from "../Loader/Loader";
import ServiceCard from "../ServiceCard/ServiceCard";
import "./AllServices.css";

const AllServices = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    fetch("https://food-for-you-server.vercel.app/allservices")
      .then((res) => res.json())
      .then((data) => {
        setServices(data);
        setLoading(false);
      });
  }, []);

  return (
    <div>
      {loading ? (
        <div className="d-flex justify-content-center align-items-center">
          <Loader />
        </div>
      ) : (
        <section className="containe mb-5 all-services mt-service">
          <div className="mx-auto w-discover">
            <h2 className="text-center fw-bold mb-3 fs-my-4 fs-mob form-header mb-services-header">
              <TypeAnimation
                sequence={[`All Delivery Services (${services.length})`, 3000]}
                speed={60}
                cursor={false}
                repeat={Infinity}
              />
            </h2>
          </div>

          <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4 m-service">
            {services.map((service) => (
              <ServiceCard key={service._id} service={service}></ServiceCard>
            ))}
          </div>
        </section>
      )}
    </div>
  );
};

export default AllServices;
